export default __webpack_public_path__ + "static/media/gallery2.1dc3c7b3.png";